import { Component, OnInit } from '@angular/core';
import { BreadcrumbsService } from '../services/utils/breadcrumbs.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-not-found',
  templateUrl: './not-found.component.html',
  styleUrls: ['./not-found.component.scss']
})
export class NotFoundComponent implements OnInit {

  constructor(
    private breadcrumbsService: BreadcrumbsService,
    private translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    this.setBreadcrumb('Error');

    this.translateService.get('ERRORS.ERROR').subscribe(title => this.setBreadcrumb(title));
  }

  private setBreadcrumb(title: string) {
    this.breadcrumbsService.sendBreadcrumbs(
      {
        breadcrumbs:
          [
            { title: title, url: '/' },
          ]
      }
    );
  }

}
